<h2 mat-dialog-title>{{ data.title || 'Select File' }}</h2>

<mat-dialog-content class="file-browser-content">
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <div *ngIf="error" class="error-message">
    {{ error }}
  </div>

  <div *ngIf="!isLoading && !error">
    <!-- Storage Area Selector -->
    <div class="storage-selector" *ngIf="allowedStorageAreas.length > 1">
      <mat-button-toggle-group [(ngModel)]="currentStorageArea" (change)="onStorageAreaChange($event)">
        <mat-button-toggle value="user" *ngIf="allowedStorageAreas.includes('user')">
          <mat-icon>folder</mat-icon> My Files
        </mat-button-toggle>
        <mat-button-toggle value="organization" *ngIf="allowedStorageAreas.includes('organization')">
          <mat-icon>business</mat-icon> Organization
        </mat-button-toggle>
        <mat-button-toggle value="admin" *ngIf="allowedStorageAreas.includes('admin')">
          <mat-icon>admin_panel_settings</mat-icon> Admin
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <!-- Breadcrumbs -->
    <div class="breadcrumbs">
      <span *ngFor="let crumb of breadcrumbs; let last = last">
        <a (click)="onBreadcrumbClick(crumb)" [class.active]="last">{{ crumb.name }}</a>
        <span *ngIf="!last"> / </span>
      </span>
    </div>

    <!-- File List -->
    <div class="file-list">
      <div *ngIf="currentItems.length === 0" class="empty-state">
        <mat-icon>folder_open</mat-icon>
        <p>No files or folders in this location</p>
      </div>

      <div
        *ngFor="let item of currentItems"
        class="file-item"
        [class.selected]="selectedFilePath === item.path"
        [class.folder]="item.isFolder"
        (click)="onItemClick(item)"
        (dblclick)="onItemDoubleClick(item)">
        <mat-icon class="file-icon">{{ getFileIcon(item) }}</mat-icon>
        <div class="file-details">
          <div class="file-name">{{ item.name }}</div>
          <div class="file-meta" *ngIf="!item.isFolder && item.fileData">
            {{ formatFileSize(item.fileData.size) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <input type="file" #fileUploadInput style="display: none" (change)="onUploadFileSelected($event)">
  <button mat-stroked-button (click)="fileUploadInput.click()" [disabled]="isUploading" class="upload-btn">
    <mat-icon>upload</mat-icon>
    {{ isUploading ? 'Uploading...' : 'Upload File' }}
  </button>
  <span style="flex: 1"></span>
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="selectFile()" [disabled]="!selectedFilePath || isUploading">
    Select
  </button>
</mat-dialog-actions>
